import React from 'react';
import './StageIndicator.css';

const STAGES = [
  { number: 1, label: 'Create Program' },
  { number: 2, label: 'Link Bill Items' },
  { number: 3, label: 'Assign Students' },
];

/**
 * StageIndicator Component
 *
 * Displays a visual progress indicator for a 3-stage workflow.
 * Use on pages representing stages 2 and 3.
 *
 * @param {number} currentStage - The current stage number (1, 2, or 3)
 */
export default function StageIndicator({ currentStage = 1 }) {
  return (
    <div className="stage-indicator-container">
      <div className="stages-wrapper">
        {STAGES.map((stage, index) => {
          const isCompleted = stage.number < currentStage;
          const isCurrent = stage.number === currentStage;
          // const isUpcoming = stage.number > currentStage;

          let stateClass = 'upcoming';
          if (isCompleted) stateClass = 'completed';
          if (isCurrent) stateClass = 'current';

          return (
            <React.Fragment key={stage.number}>
              <div className={`stage ${stateClass}`}>
                <div className="stage-icon">
                  {isCompleted ? (
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  ) : (
                    <span>{stage.number}</span>
                  )}
                </div>
                <div className="stage-label">{stage.label}</div>
              </div>

              {/* Connector line - render after each stage except the last */}
              {index < STAGES.length - 1 && (
                <div
                  className={`stage-connector ${isCompleted ? 'completed' : ''}`}
                ></div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
